var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "routine-list" },
      _vm._l(_vm.items, function (item, index) {
        return _c("products-item", {
          key: index,
          attrs: { item: item, message: _vm.message },
          on: {
            "product-clicked": function ($event) {
              return _vm.$emit("product-clicked", $event)
            },
            "product-added-to-cart": function ($event) {
              return _vm.$emit("product-added-to-cart", $event)
            },
            "attribute-matching-list-expanded": function ($event) {
              return _vm.$emit("attribute-matching-list-expanded", $event)
            },
            "product-info-clicked": function ($event) {
              return _vm.$emit("product-info-clicked", $event)
            },
          },
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.routineListActionClasses }, [
      _vm.showAddRoutineToCartButton
        ? _c(
            "button",
            {
              staticClass: "add-routine-to-cart-button",
              attrs: { type: "button" },
              on: { click: _vm.addRoutineToCart },
            },
            [
              _c("add-to-cart-icon", {
                staticClass: "add-routine-to-cart-button__icon",
              }),
              _vm._v(" "),
              _c("span", { staticClass: "add-routine-to-cart-button__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("product.addRoutineToCart")) +
                    "\n      "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowingCheckOrSpinnerIcons
        ? _c(
            "div",
            { staticClass: "routine-list__actions__feedback" },
            [
              _vm.isShowingCheckIcon ? _c("add-to-cart-check") : _vm._e(),
              _vm._v(" "),
              _vm.isShowingSpinnerIcon ? _c("add-to-cart-spinner") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }